import type React from 'react';
import { Component } from 'react'
import BaseState from './BaseState';
import { RouteComponentProps } from 'react-router-dom';
import SessionHelper from './SessionHelper';
import { ConstantMessage } from '.';
type ModelValueChangeEvent =
  | React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>
  | { target: { id?: string; name?: string; value: unknown } };

export default abstract class BaseComponentCore<T, U> extends Component<T, BaseState<U>> {

  ViewModel: U | undefined = undefined;
  /** False after unmount — guards async setState (e.g. session-expiry redirect mid-flight). */
  private _isMountedFlag = true;

  constructor(props: T) {
    super(props)
    this.HandleAuthentication(props);
  }

  componentWillUnmount() {
    this._isMountedFlag = false;
  }

  protected get isComponentMounted(): boolean {
    return this._isMountedFlag;
  }

  // componentDidMount(){
  // this.HandleAuthentication(this.props);
  // }

  HandleAuthentication(props: T) {
    var user = SessionHelper.GetSession();
    var props2 = props as unknown as RouteComponentProps
    //debugger
    if (user === null && props2.location && props2.location.pathname !== ConstantMessage.LoginPagePath) {
      props2?.history?.push(ConstantMessage.LoginPagePath);
    }

  }


  SetModelValue = (event: ModelValueChangeEvent) => {

    const { target: { id, name, value } } = event;
    var propertyName = id;
    if (!propertyName) {
      propertyName = name;
    }
    if (!propertyName) {
      alert("propertyName undefined")
      return;
    }

    Object.assign(this.state.Model, { [propertyName]: value })
    //console.log(this.state.Model)
    if (!this._isMountedFlag) {
      return;
    }
    this.setState({
      Model: this.state.Model
    } as Pick<BaseState<U>, keyof BaseState<U>>);
  }

  UpdateViewModelUnknown(Model: unknown) {
    if (!this._isMountedFlag) {
      return;
    }
    this.setState({
      Model: Model as U
    })
  }
  UpdateViewModel(Model?: U) {
    if (!this._isMountedFlag) {
      return;
    }
    this.setState({
      Model: Model !== undefined ? Model : this.state.Model
    })
  }

}
